import { render, staticRenderFns } from "./WpLabReceive.vue?vue&type=template&id=7f272046&scoped=true"
import script from "./WpLabReceive.vue?vue&type=script&lang=js"
export * from "./WpLabReceive.vue?vue&type=script&lang=js"
import style0 from "./WpLabReceive.vue?vue&type=style&index=0&id=7f272046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f272046",
  null
  
)

export default component.exports